import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Grid, Tab } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { ModalComponent } from '../../widgets';
import BotonComponent from '../dashboard/components/BotonNuevo';
import { allEventosAction, setActivoEventosAction } from './EventosAction';
import CalendarioEventosComponent from './components/CalendarioEventos';
import FormEventos from './components/FormEventos';
import ListadoParticipantesComponent from './components/ListadoParticipantes';

const EventosView = () => {
  const dispatch = Redux.useDispatch();

  const eventosStore = Redux.useSelector((state) => state.eventos);

  const [openModalForm, setOpenModalForm] = React.useState(false);

  const [tab, setValue] = React.useState('1');

  const handleTabs = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Grid container spacing={1}>
      <Grid item md={12}>
        <BotonComponent
          click={async () => {
            await setActivoEventosAction(dispatch, null);
            setOpenModalForm(true);
          }}
          green
          addIcon
          mr={2}
        />
        <BotonComponent
          click={async () => {
            await setActivoEventosAction(dispatch, null);
            await allEventosAction(dispatch, eventosStore.params);
          }}
          disabled={eventosStore.all.length === 0 || eventosStore.loadingAll}
          white
          refreshIcon
          text={eventosStore.loadingAll ? 'Actualizando...' : 'Actualizar'}
        />
      </Grid>
      <Grid item md={12}>
        <CalendarioEventosComponent setOpenModalForm={setOpenModalForm} />
        {/* <ListadoEventos setOpenModalForm={(val) => setOpenModalForm(val)} /> */}
      </Grid>
      <ModalComponent
        id="modalFormEventos"
        maxWidth="lg"
        title={`${
          eventosStore.activo
            ? `Editar ${eventosStore.activo.nombre}`
            : 'Nueva evento'
        }`}
        open={openModalForm}
        onClose={() => setOpenModalForm(!openModalForm)}
      >
        <TabContext value={tab}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList onChange={handleTabs} aria-label="lab API tabs example">
              <Tab label="Información" value="1" />
              <Tab label="Participantes" value="2" />
            </TabList>
          </Box>
          <TabPanel value="1">
            <FormEventos
              activo={eventosStore.activo}
              setOpenModalForm={(val) => setOpenModalForm(val)}
            />
          </TabPanel>
          <TabPanel value="2">
            <ListadoParticipantesComponent />
          </TabPanel>
        </TabContext>
      </ModalComponent>
    </Grid>
  );
};

export default EventosView;
